document.documentElement.classList.remove("no-js");

const clearReusePhoto = () => {
  try {
    sessionStorage.removeItem("philuReusePhoto");
  } catch (_error) {
    // Storage can be unavailable in strict privacy modes; purchasing must still work.
  }
};

const scrollRailToStart = (rail) => {
  if (!rail || !window.matchMedia("(max-width: 760px)").matches) return;
  if (typeof rail.scrollTo === "function") rail.scrollTo({ left: 0, behavior: "smooth" });
  else rail.scrollLeft = 0;
};

document.querySelectorAll("[data-collection-switcher]").forEach((switcher) => {
  const tabs = switcher.querySelectorAll("[data-collection-tab]");
  const panels = switcher.querySelectorAll("[data-collection-panel]");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.collectionTab;
      tabs.forEach((candidate) => {
        const active = candidate === tab;
        candidate.classList.toggle("active", active);
        candidate.setAttribute("aria-selected", String(active));
      });
      panels.forEach((panel) => {
        const active = panel.dataset.collectionPanel === target;
        panel.classList.toggle("active", active);
        panel.hidden = !active;
      });
    });
  });
});

document.querySelectorAll("[data-gallery]").forEach((gallery) => {
  const mainImage = gallery.querySelector("[data-gallery-main]");
  const buttons = gallery.querySelectorAll("[data-gallery-button]");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      if (!mainImage) return;
      mainImage.src = button.dataset.src || mainImage.src;
      mainImage.alt = button.dataset.alt || "PhilU projection jewellery";
      const rail = gallery.querySelector("[data-product-media-rail]");
      scrollRailToStart(rail);
      buttons.forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle("active", active);
        candidate.setAttribute("aria-pressed", String(active));
      });
    });
  });
});

document.querySelectorAll("[data-product-panel]").forEach((panel) => {
  const form = panel.querySelector(".philu-product-form");
  const variantInput = panel.querySelector("[data-variant-input]");
  const price = panel.querySelector("[data-variant-price]");
  const variantScript = panel.querySelector("[data-product-variants]");
  const optionChoices = panel.querySelectorAll("[data-option-choice]");
  const selectionSummary = panel.querySelector("[data-selection-summary]");
  const photoInput = panel.querySelector("[data-photo-input]");
  const photoLater = panel.querySelector("[data-photo-later]");
  const photoWorkflow = panel.querySelector("[data-photo-workflow]");
  const photoWorkflowChoices = panel.querySelectorAll("[data-photo-workflow-choice]");
  const photoUploadPanel = panel.querySelector("[data-photo-upload-panel]");
  const photoLaterPanel = panel.querySelector("[data-photo-later-panel]");
  const photoPreview = panel.querySelector("[data-photo-preview]");
  const uploadTitle = panel.querySelector("[data-upload-title]");
  const uploadZone = panel.querySelector("[data-upload-zone]");
  const photoFeedback = panel.querySelector("[data-photo-feedback]");
  const photoEditor = panel.querySelector("[data-photo-editor]");
  const photoCanvas = panel.querySelector("[data-photo-canvas]");
  const photoZoom = panel.querySelector("[data-photo-zoom]");
  const photoApply = panel.querySelector("[data-photo-apply]");
  const photoOriginal = panel.querySelector("[data-photo-original]");
  const photoRotateButtons = panel.querySelectorAll("[data-photo-rotate]");
  const photoReset = panel.querySelector("[data-photo-reset]");
  const reusedPhoto = panel.querySelector("[data-reused-photo]");
  const replaceLine = panel.querySelector("[data-replace-line]");
  const addButton = panel.querySelector("[data-add-button]");
  const error = panel.querySelector("[data-form-error]");
  const photoStatus = panel.querySelector("[data-photo-status]");
  const stickyPrice = panel.querySelector("[data-sticky-price]");
  const stickySelection = panel.querySelector("[data-sticky-selection]");
  const stickyAction = panel.querySelector("[data-sticky-action]");
  const galleryMain = document.querySelector("[data-gallery-main]");
  const galleryButtons = document.querySelectorAll("[data-gallery-button]");
  const galleryPhoto = document.querySelector("[data-gallery-photo]");
  let objectUrl = "";
  let editorImage = null;
  let variants = [];
  let selectedOptions = [];
  let photoAttached = false;
  let photoRotation = 0;
  let photoOffsetX = 0;
  let photoOffsetY = 0;
  let photoPointerId = null;
  let photoPointerX = 0;
  let photoPointerY = 0;
  let reusedPhotoActive = false;
  let selectedPhotoWorkflow = "";

  try {
    variants = variantScript ? JSON.parse(variantScript.textContent || "[]") : [];
  } catch (_error) {
    variants = [];
  }

  const showPhotoFeedback = (message, tone) => {
    if (!photoFeedback) return;
    photoFeedback.textContent = message || "";
    photoFeedback.dataset.tone = tone || "neutral";
    photoFeedback.hidden = !message;
  };

  const syncStickyState = () => {
    const hasPhoto = Boolean(photoAttached || (photoInput && photoInput.files && photoInput.files.length));
    const sendingLater = Boolean(photoLater && photoLater.checked);
    const ready = hasPhoto || sendingLater;
    if (stickyAction) stickyAction.textContent = ready ? "Add to bag" : "Choose photo";
    return ready;
  };

  const applyVariant = (variant, updateUrl) => {
    if (!variant) return;
    selectedOptions = variant.options.slice();
    if (variantInput) variantInput.value = variant.id;
    if (price) price.textContent = variant.price;
    if (stickyPrice) stickyPrice.textContent = variant.price;
    if (selectionSummary) selectionSummary.textContent = variant.options.join(" · ");
    if (stickySelection) stickySelection.textContent = variant.options.join(" · ");

    optionChoices.forEach((candidate) => {
      const index = Number(candidate.dataset.optionIndex);
      const selected = selectedOptions[index] === candidate.dataset.optionValue;
      const available = variants.some((item) => item.available && item.options[index] === candidate.dataset.optionValue);
      candidate.classList.toggle("selected", selected);
      candidate.classList.toggle("unavailable", !available);
      candidate.disabled = !available;
      candidate.setAttribute("aria-pressed", String(selected));
      candidate.setAttribute("aria-disabled", String(!available));
      const unavailableLabel = candidate.querySelector("[data-unavailable-label]");
      if (unavailableLabel) unavailableLabel.hidden = available;
    });

    if (galleryMain) {
      let targetButton = null;
      if (variant.imageId) {
        targetButton = Array.from(galleryButtons).find((button) => String(button.dataset.imageId) === String(variant.imageId)) || null;
      }
      if (!targetButton) {
        const selectedColour = panel.querySelector(".option-values--colour .option-choice.selected");
        const colour = selectedColour ? String(selectedColour.dataset.optionValue || "").toLowerCase() : "";
        if (colour) {
          targetButton = Array.from(galleryButtons).find((button) => {
            const alt = (button.dataset.alt || "").toLowerCase();
            return alt.includes("/ " + colour) || alt.includes("– " + colour) || alt.includes("- " + colour);
          }) || null;
        }
      }
      if (!targetButton) {
        const searchableOptions = variant.options.slice().sort((a, b) => b.length - a.length);
        targetButton = Array.from(galleryButtons).find((button) => {
          const alt = (button.dataset.alt || "").toLowerCase();
          return searchableOptions.some((option) => alt.includes(String(option).toLowerCase()));
        }) || null;
      }

      const nextImage = variant.image || (targetButton && targetButton.dataset.src);
      const nextAlt = variant.imageAlt || (targetButton && targetButton.dataset.alt);
      if (nextImage) galleryMain.src = nextImage;
      if (nextAlt) galleryMain.alt = nextAlt;
      const mediaRail = document.querySelector("[data-product-media-rail]");
      scrollRailToStart(mediaRail);

      galleryButtons.forEach((button) => {
        const active = button === targetButton;
        button.classList.toggle("active", active);
        button.setAttribute("aria-pressed", String(active));
      });
    }

    if (updateUrl && window.history && window.history.replaceState) {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", nextUrl.toString());
    }
  };

  const updateReadyState = () => {
    const hasPhoto = Boolean(photoAttached || (photoInput && photoInput.files && photoInput.files.length));
    const sendingLater = Boolean(photoLater && photoLater.checked);
    const ready = hasPhoto || sendingLater;

    if (photoStatus) {
      photoStatus.value = hasPhoto ? "Photo uploaded with item" : (sendingLater ? "Photo to follow" : "");
    }
    if (addButton && addButton.getAttribute("aria-busy") !== "true") {
      addButton.disabled = !ready;
      addButton.textContent = ready
        ? (addButton.dataset.readyLabel || "Add personalised jewellery to bag")
        : (selectedPhotoWorkflow === "upload" ? "Add a photo to continue" : "Choose how to add your photo");
    }
    if (error && ready) error.hidden = true;
    syncStickyState();
    return ready;
  };

  const drawPhotoCrop = () => {
    if (!photoCanvas || !editorImage) return;
    const context = photoCanvas.getContext("2d");
    if (!context) return;
    const zoom = Number(photoZoom && photoZoom.value) || 1;
    const quarterTurn = Math.abs(photoRotation % 180) === 90;
    const rotatedWidth = quarterTurn ? editorImage.naturalHeight : editorImage.naturalWidth;
    const rotatedHeight = quarterTurn ? editorImage.naturalWidth : editorImage.naturalHeight;
    const scale = Math.max(photoCanvas.width / rotatedWidth, photoCanvas.height / rotatedHeight) * zoom;
    const maxOffsetX = Math.max(0, (rotatedWidth * scale - photoCanvas.width) / 2);
    const maxOffsetY = Math.max(0, (rotatedHeight * scale - photoCanvas.height) / 2);
    photoOffsetX = Math.max(-maxOffsetX, Math.min(maxOffsetX, photoOffsetX));
    photoOffsetY = Math.max(-maxOffsetY, Math.min(maxOffsetY, photoOffsetY));
    context.fillStyle = "#fffaf4";
    context.fillRect(0, 0, photoCanvas.width, photoCanvas.height);
    context.save();
    context.translate(photoCanvas.width / 2 + photoOffsetX, photoCanvas.height / 2 + photoOffsetY);
    context.rotate(photoRotation * Math.PI / 180);
    context.drawImage(
      editorImage,
      -editorImage.naturalWidth * scale / 2,
      -editorImage.naturalHeight * scale / 2,
      editorImage.naturalWidth * scale,
      editorImage.naturalHeight * scale
    );
    context.restore();
  };

  const assessPhotoQuality = (image) => {
    const warnings = [];
    if (image.naturalWidth < 600 || image.naturalHeight < 600) warnings.push("This photo is quite small");
    try {
      const sample = document.createElement("canvas");
      sample.width = 64;
      sample.height = 64;
      const context = sample.getContext("2d", { willReadFrequently: true });
      context.drawImage(image, 0, 0, 64, 64);
      const pixels = context.getImageData(0, 0, 64, 64).data;
      let total = 0;
      const values = [];
      for (let index = 0; index < pixels.length; index += 4) {
        const luminance = 0.2126 * pixels[index] + 0.7152 * pixels[index + 1] + 0.0722 * pixels[index + 2];
        values.push(luminance);
        total += luminance;
      }
      const average = total / values.length;
      const variance = values.reduce((sum, value) => sum + Math.pow(value - average, 2), 0) / values.length;
      if (average < 58) warnings.push("The image appears dark");
      if (Math.sqrt(variance) < 24) warnings.push("The image has low contrast");
    } catch (_error) {
      // Quality guidance is advisory and never blocks an otherwise valid file.
    }
    return warnings;
  };

  const resetPhotoEditor = () => {
    editorImage = null;
    photoRotation = 0;
    photoOffsetX = 0;
    photoOffsetY = 0;
    photoPointerId = null;
    if (photoEditor) photoEditor.hidden = true;
    if (photoZoom) photoZoom.value = "1";
  };

  const trackPhotoWorkflow = (mode) => {
    document.dispatchEvent(new CustomEvent("philu:photo-workflow-selected", { detail: { mode } }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: "photo_workflow_selected", photo_workflow: mode });
  };

  const selectPhotoWorkflow = (mode, track = true) => {
    if (!["upload", "later"].includes(mode)) return;
    selectedPhotoWorkflow = mode;
    photoWorkflowChoices.forEach((choice) => {
      const active = choice.dataset.photoWorkflowChoice === mode;
      choice.classList.toggle("is-selected", active);
      choice.setAttribute("aria-pressed", String(active));
    });
    if (photoUploadPanel) photoUploadPanel.hidden = mode !== "upload";
    if (photoLaterPanel) photoLaterPanel.hidden = mode !== "later";
    if (photoLater) {
      const nextChecked = mode === "later";
      if (photoLater.checked !== nextChecked) {
        photoLater.checked = nextChecked;
        photoLater.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
    if (track) trackPhotoWorkflow(mode);
    updateReadyState();
  };

  photoWorkflowChoices.forEach((choice) => {
    choice.addEventListener("click", () => {
      selectPhotoWorkflow(choice.dataset.photoWorkflowChoice);
      const target = choice.dataset.photoWorkflowChoice === "upload" ? photoInput : photoLaterPanel;
      if (target) target.focus ? target.focus({ preventScroll: true }) : null;
    });
  });

  const createPreviewFile = async (file) => {
    const isHeic = /\.(heic|heif)$/i.test(file.name) || /image\/(heic|heif)/i.test(file.type || "");
    if (!isHeic) return { file, converted: false };
    if (typeof createImageBitmap !== "function") return { file, converted: false };
    try {
      const bitmap = await createImageBitmap(file);
      const maxSide = 4000;
      const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.max(1, Math.round(bitmap.width * scale));
      canvas.height = Math.max(1, Math.round(bitmap.height * scale));
      const context = canvas.getContext("2d");
      if (!context) throw new Error("Canvas unavailable");
      context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      if (typeof bitmap.close === "function") bitmap.close();
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.92));
      if (!blob) throw new Error("Conversion unavailable");
      const converted = new File([blob], file.name.replace(/\.(heic|heif)$/i, "") + ".jpg", { type: "image/jpeg" });
      try {
        const transfer = new DataTransfer();
        transfer.items.add(converted);
        photoInput.files = transfer.files;
      } catch (_) {
        // Preview can use the converted copy while the original HEIC remains attached.
      }
      return { file: converted, converted: true };
    } catch (_) {
      return { file, converted: false };
    }
  };

  optionChoices.forEach((choice) => {
    choice.addEventListener("click", () => {
      const optionIndex = Number(choice.dataset.optionIndex);
      const nextOptions = selectedOptions.slice();
      nextOptions[optionIndex] = choice.dataset.optionValue;
      let variant = variants.find((candidate) => candidate.available && candidate.options.every((value, index) => value === nextOptions[index]));

      if (!variant) {
        variant = variants.find((candidate) => candidate.available && candidate.options[optionIndex] === choice.dataset.optionValue);
      }
      applyVariant(variant, true);
    });
  });

  const initialVariant = variants.find((variant) => String(variant.id) === String(variantInput && variantInput.value)) || variants.find((variant) => variant.available);
  applyVariant(initialVariant, false);

  const queryParameters = new URLSearchParams(window.location.search);
  const replaceLineKey = queryParameters.get("replace_line");
  if (replaceLine && replaceLineKey) {
    replaceLine.value = replaceLineKey;
    replaceLine.disabled = false;
  }

  try {
    const reusePayload = JSON.parse(sessionStorage.getItem("philuReusePhoto") || "null");
    const fresh = reusePayload && Date.now() - Number(reusePayload.createdAt || 0) < 30 * 60 * 1000;
    const sameProduct = reusePayload && reusePayload.productPath === panel.dataset.productPath;
    if (fresh && sameProduct && /^https:\/\//.test(reusePayload.photoUrl || "")) {
      reusedPhoto.value = reusePayload.photoUrl;
      reusedPhoto.disabled = false;
      reusedPhotoActive = true;
      photoAttached = true;
      photoInput.name = "";
      if (photoPreview) {
        photoPreview.src = reusePayload.photoUrl;
        photoPreview.hidden = false;
      }
      if (uploadTitle) uploadTitle.textContent = "Using the same attached photo";
      showPhotoFeedback("Photo attached securely ✓ Choose another photo if you want to replace it.", "success");
      selectPhotoWorkflow("upload", false);
    } else if (reusePayload) {
      clearReusePhoto();
    }
  } catch (_error) {
    clearReusePhoto();
  }

  if (photoInput) {
    photoInput.addEventListener("change", async () => {
      const file = photoInput.files && photoInput.files[0];
      if (file && reusedPhotoActive) {
        reusedPhotoActive = false;
        if (reusedPhoto) {
          reusedPhoto.disabled = true;
          reusedPhoto.value = "";
        }
        photoInput.name = photoInput.dataset.photoPropertyName || "properties[Photo]";
        clearReusePhoto();
      }
      photoAttached = Boolean(file);
      resetPhotoEditor();

      if (!file) {
        if (photoPreview) photoPreview.hidden = true;
        if (uploadTitle) uploadTitle.textContent = "Choose and preview your photo";
        showPhotoFeedback("", "neutral");
        updateReadyState();
        return;
      }

      const extensionAllowed = /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name);
      const typeAllowed = !file.type || ["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif"].includes(file.type.toLowerCase());
      if (!extensionAllowed || !typeAllowed) {
        photoInput.value = "";
        photoAttached = false;
        if (photoPreview) photoPreview.hidden = true;
        if (uploadTitle) uploadTitle.textContent = "Choose a supported photo";
        showPhotoFeedback("Please choose a JPG, PNG, WEBP, HEIC or HEIF image.", "error");
        updateReadyState();
        return;
      }

      if (file.size > 20 * 1024 * 1024) {
        photoInput.value = "";
        photoAttached = false;
        if (photoPreview) photoPreview.hidden = true;
        if (uploadTitle) uploadTitle.textContent = "Photo is too large";
        showPhotoFeedback("Please choose an image smaller than 20MB.", "error");
        updateReadyState();
        return;
      }

      selectPhotoWorkflow("upload", false);
      const prepared = await createPreviewFile(file);
      const previewFile = prepared.file;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(previewFile);
      if (uploadTitle) uploadTitle.textContent = prepared.converted ? "HEIC converted and ready to position" : "Photo ready to position";

      const browserPreviewable = /\.(jpe?g|png|webp)$/i.test(previewFile.name) || ["image/jpeg", "image/png", "image/webp"].includes(String(previewFile.type || "").toLowerCase());
      if (!browserPreviewable) {
        if (photoPreview) photoPreview.hidden = true;
        showPhotoFeedback("Your HEIC/HEIF photo is attached. This browser cannot create a crop preview, so PhilU will use the original file.", "neutral");
        updateReadyState();
        return;
      }

      if (photoPreview) {
        photoPreview.src = objectUrl;
        photoPreview.hidden = false;
      }
      if (galleryPhoto) {
        const galleryImage = galleryPhoto.querySelector("img");
        if (galleryImage) galleryImage.src = objectUrl;
        galleryPhoto.hidden = false;
      }

      const image = new Image();
      image.onload = () => {
        editorImage = image;
        photoRotation = 0;
        photoOffsetX = 0;
        photoOffsetY = 0;
        if (photoEditor) photoEditor.hidden = false;
        if (photoZoom) photoZoom.value = "1";
        drawPhotoCrop();
        const warnings = assessPhotoQuality(image);
        if (warnings.length) {
          showPhotoFeedback(warnings.join(". ") + ". A brighter, sharper original may project more clearly.", "warning");
        } else {
          showPhotoFeedback("Photo attached securely ✓ Adjust the crop or keep the original.", "success");
        }
      };
      image.onerror = () => {
        resetPhotoEditor();
        showPhotoFeedback("Photo attached. A browser preview is unavailable, but you can still add the item.", "neutral");
      };
      image.src = objectUrl;
      updateReadyState();
    });
  }

  if (photoZoom) photoZoom.addEventListener("input", drawPhotoCrop);
  if (photoCanvas) {
    const finishPhotoDrag = (event) => {
      if (photoPointerId !== event.pointerId) return;
      if (photoCanvas.hasPointerCapture && photoCanvas.hasPointerCapture(photoPointerId)) photoCanvas.releasePointerCapture(photoPointerId);
      photoPointerId = null;
      photoCanvas.classList.remove("is-dragging");
    };

    photoCanvas.addEventListener("pointerdown", (event) => {
      if (!editorImage) return;
      photoPointerId = event.pointerId;
      photoPointerX = event.clientX;
      photoPointerY = event.clientY;
      photoCanvas.setPointerCapture(event.pointerId);
      photoCanvas.classList.add("is-dragging");
      event.preventDefault();
    });
    photoCanvas.addEventListener("pointermove", (event) => {
      if (photoPointerId !== event.pointerId || !editorImage) return;
      const rect = photoCanvas.getBoundingClientRect();
      const scaleX = photoCanvas.width / Math.max(1, rect.width);
      const scaleY = photoCanvas.height / Math.max(1, rect.height);
      photoOffsetX += (event.clientX - photoPointerX) * scaleX;
      photoOffsetY += (event.clientY - photoPointerY) * scaleY;
      photoPointerX = event.clientX;
      photoPointerY = event.clientY;
      drawPhotoCrop();
    });
    photoCanvas.addEventListener("pointerup", finishPhotoDrag);
    photoCanvas.addEventListener("pointercancel", finishPhotoDrag);
    photoCanvas.addEventListener("keydown", (event) => {
      if (!editorImage || !["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(event.key)) return;
      event.preventDefault();
      const step = event.shiftKey ? 40 : 14;
      if (event.key === "ArrowLeft") photoOffsetX -= step;
      if (event.key === "ArrowRight") photoOffsetX += step;
      if (event.key === "ArrowUp") photoOffsetY -= step;
      if (event.key === "ArrowDown") photoOffsetY += step;
      drawPhotoCrop();
    });
  }
  photoRotateButtons.forEach((button) => {
    button.addEventListener("click", () => {
      photoRotation = (photoRotation + Number(button.dataset.photoRotate || 0)) % 360;
      photoOffsetX = 0;
      photoOffsetY = 0;
      drawPhotoCrop();
    });
  });
  if (photoReset) {
    photoReset.addEventListener("click", () => {
      photoRotation = 0;
      photoOffsetX = 0;
      photoOffsetY = 0;
      if (photoZoom) photoZoom.value = "1";
      drawPhotoCrop();
    });
  }

  if (photoApply && photoCanvas && photoInput) {
    photoApply.addEventListener("click", () => {
      photoCanvas.toBlob((blob) => {
        if (!blob) {
          showPhotoFeedback("We could not create the crop. Your original photo is still attached.", "warning");
          return;
        }

        try {
          const original = photoInput.files && photoInput.files[0];
          const baseName = original ? original.name.replace(/\.[^.]+$/, "") : "philu-photo";
          const croppedFile = new File([blob], baseName + "-cropped.jpg", { type: "image/jpeg" });
          const transfer = new DataTransfer();
          transfer.items.add(croppedFile);
          photoInput.files = transfer.files;
          if (photoPreview) {
            photoPreview.src = photoCanvas.toDataURL("image/jpeg", 0.92);
            photoPreview.hidden = false;
          }
          if (uploadTitle) uploadTitle.textContent = "Cropped photo ready";
          if (photoEditor) photoEditor.hidden = true;
          showPhotoFeedback("Photo attached securely ✓ Crop saved with this item.", "success");
          updateReadyState();
        } catch (_error) {
          showPhotoFeedback("Your browser kept the original photo. It is still safely attached.", "warning");
          if (photoEditor) photoEditor.hidden = true;
        }
      }, "image/jpeg", 0.92);
    });
  }

  if (photoOriginal) {
    photoOriginal.addEventListener("click", () => {
      if (photoEditor) photoEditor.hidden = true;
      showPhotoFeedback("Photo attached securely ✓ Original photo kept.", "success");
      updateReadyState();
    });
  }

  if (photoLater) {
    photoLater.addEventListener("change", () => {
      if (photoLater.checked && photoInput) {
        photoInput.value = "";
        photoInput.name = photoInput.dataset.photoPropertyName || "properties[Photo]";
        photoAttached = false;
        reusedPhotoActive = false;
        if (reusedPhoto) {
          reusedPhoto.disabled = true;
          reusedPhoto.value = "";
        }
        clearReusePhoto();
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = "";
        if (photoPreview) photoPreview.hidden = true;
        if (galleryPhoto) galleryPhoto.hidden = true;
        if (uploadTitle) uploadTitle.textContent = "Choose and preview your photo";
        resetPhotoEditor();
        showPhotoFeedback("Photo will follow after checkout.", "neutral");
      } else {
        showPhotoFeedback("", "neutral");
      }
      updateReadyState();
    });
  }

  if (stickyAction) {
    stickyAction.addEventListener("click", () => {
      if (updateReadyState() && form) {
        if (typeof form.requestSubmit === "function") form.requestSubmit(addButton || undefined);
        else form.submit();
        return;
      }
      const workflowTarget = photoWorkflow || uploadZone;
      if (workflowTarget) workflowTarget.scrollIntoView({ behavior: "smooth", block: "center" });
      if (!selectedPhotoWorkflow && photoWorkflowChoices.length) photoWorkflowChoices[0].focus({ preventScroll: true });
      else if (selectedPhotoWorkflow === "upload" && photoInput) photoInput.focus({ preventScroll: true });
    });
  }

  if (form) {
    form.addEventListener("submit", (event) => {
      if (!updateReadyState()) {
        event.preventDefault();
        if (error) error.hidden = false;
        const workflowTarget = photoWorkflow || uploadZone;
        if (workflowTarget) workflowTarget.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      if (addButton) {
        addButton.disabled = true;
        addButton.setAttribute("aria-busy", "true");
        addButton.textContent = "Adding to bag…";
      }
      if (stickyAction) {
        stickyAction.disabled = true;
        stickyAction.textContent = "Adding…";
      }
      clearReusePhoto();
    });
  }

  updateReadyState();
});

const addBusinessDays = (date, days) => {
  const result = new Date(date);
  let remaining = Math.max(0, Number(days) || 0);
  while (remaining > 0) {
    result.setDate(result.getDate() + 1);
    const weekday = result.getDay();
    if (weekday !== 0 && weekday !== 6) remaining -= 1;
  }
  return result;
};

const dateInTimezone = (timeZone) => {
  try {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(new Date());
    const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
    return new Date(Number(values.year), Number(values.month) - 1, Number(values.day), 12);
  } catch (_error) {
    return new Date();
  }
};

const formatEstimateDate = (date) => new Intl.DateTimeFormat("en-AU", {
  day: "numeric",
  month: "short"
}).format(date);

const formatDateRange = (start, end) => {
  const startText = formatEstimateDate(start);
  const endText = formatEstimateDate(end);
  return startText === endText ? startText : startText + " – " + endText;
};

document.querySelectorAll("[data-delivery-estimate]").forEach((estimate) => {
  const productionMin = Number(estimate.dataset.productionMin || 2);
  const productionMax = Math.max(productionMin, Number(estimate.dataset.productionMax || 3));
  const deliveryMin = Number(estimate.dataset.deliveryMin || 5);
  const deliveryMax = Math.max(deliveryMin, Number(estimate.dataset.deliveryMax || 8));
  const today = dateInTimezone(estimate.dataset.deliveryTimezone || "Australia/Sydney");
  const dispatchStart = addBusinessDays(today, productionMin);
  const dispatchEnd = addBusinessDays(today, productionMax);
  const arrivalStart = addBusinessDays(dispatchStart, deliveryMin);
  const arrivalEnd = addBusinessDays(dispatchEnd, deliveryMax);
  const order = estimate.querySelector("[data-order-date]");
  const dispatch = estimate.querySelector("[data-dispatch-date]");
  const arrival = estimate.querySelector("[data-arrival-date]");
  if (order) order.textContent = formatEstimateDate(today);
  if (dispatch) dispatch.textContent = formatDateRange(dispatchStart, dispatchEnd);
  if (arrival) arrival.textContent = formatDateRange(arrivalStart, arrivalEnd);
});

document.querySelectorAll("[data-reuse-photo]").forEach((button) => {
  button.addEventListener("click", () => {
    if (button.disabled) return;
    button.disabled = true;
    button.textContent = "Preparing photo…";
    try {
      const target = new URL(button.dataset.productUrl, window.location.origin);
      sessionStorage.setItem("philuReusePhoto", JSON.stringify({
        photoUrl: button.dataset.photoUrl,
        productPath: target.pathname,
        createdAt: Date.now()
      }));
      window.location.assign(target.toString());
    } catch (_error) {
      button.disabled = false;
      button.textContent = "Make another with the same photo";
      const status = document.querySelector("[data-cart-operation-status]");
      if (status) {
        status.hidden = false;
        status.dataset.tone = "error";
        status.textContent = "We could not prepare that photo. Please open the item and upload it again.";
      }
    }
  });
});

const replaceItems = Array.from(document.querySelectorAll("[data-replace-line]")).filter((item) => item.dataset.replaceLine);
replaceItems.forEach(async (newItem) => {
  const oldKey = newItem.dataset.replaceLine;
  const oldItem = Array.from(document.querySelectorAll("[data-line-key]")).find((item) => item !== newItem && item.dataset.lineKey === oldKey);
  if (!oldItem || newItem.dataset.replacePending === "true") return;
  newItem.dataset.replacePending = "true";
  const status = document.querySelector("[data-cart-operation-status]");
  if (status) {
    status.hidden = false;
    status.dataset.tone = "neutral";
    status.textContent = "Updating your personalised item…";
  }
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {"Content-Type": "application/json", "Accept": "application/json"},
      body: JSON.stringify({ id: oldKey, quantity: 0 })
    });
    if (!response.ok) throw new Error("Cart update failed");
    window.location.reload();
  } catch (_error) {
    newItem.dataset.replacePending = "false";
    if (status) {
      status.hidden = false;
      status.dataset.tone = "error";
      status.textContent = "The updated item was added, but the original could not be removed. Please review both items before checkout.";
    }
  }
});


// Keep muted storefront videos moving when they enter the viewport.
if (!window.PhilUAutoplayObserver) {
  window.PhilUAutoplayObserver = true;
  const autoplayMedia = document.querySelectorAll("video[autoplay]");
  const playMedia = (media) => {
    media.muted = true;
    media.playsInline = true;
    const request = media.play();
    if (request && typeof request.catch === "function") request.catch(() => {});
  };
  if ("IntersectionObserver" in window) {
    const mediaObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) playMedia(entry.target);
        else entry.target.pause();
      });
    }, { threshold: 0.2 });
    autoplayMedia.forEach((media) => mediaObserver.observe(media));
  } else {
    autoplayMedia.forEach(playMedia);
  }
}

